// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#header__top{background-color:#f7f7f7;display:none}#header__top a{display:inline-block;font-size:14px;font-weight:400;padding:8px 20px;transition:background-color .35s ease;will-change:background-color;text-decoration:none;color:#3d3d3d}#header__top a.active,#header__top a:hover{background-color:#fff}#header__top a:hover{text-decoration:none}header.desktop #header__top{display:block}", ""]);
// Exports
module.exports = exports;
